var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmokestacksIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.84,173.79v7.05m-12.2-7.05v7.05m-12.2-7.05v7.05m-12.52-7.05v7.05M93,173.79v7.05m-24.4-7.05v7.05m12.2-7.05v7.05m60-30.81v7.06M128.64,150v7.06M116.44,150v7.06m-.52-132.26A15.83,15.83,0,0,0,101.14,35a24.08,24.08,0,1,0,8.48,20.23,15.62,15.62,0,0,0,6.3,1.31,15.85,15.85,0,1,0,0-31.7ZM169,50.31A11.36,11.36,0,1,1,157.66,39,11.36,11.36,0,0,1,169,50.31Zm-72.16,43a6.75,6.75,0,1,1-6.74-6.73A6.74,6.74,0,0,1,96.86,93.26Zm1.28,66.4H81.45l2.88-48.09H95.27ZM141.8,67.52a6.74,6.74,0,1,1-6.73-6.74A6.75,6.75,0,0,1,141.8,67.52Zm1.29,66.39H126.4l2.87-48.09h10.94ZM56.46,193.58h96.9V134.15H113.55L98.78,159.66H56.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokestacksIndustry);
export default __webpack_public_path__ + "static/media/SMOKESTACKS_INDUSTRY.57cfb2044ab1fb18853ed44af9e5865b.svg";
export { ForwardRef as ReactComponent };